import { render, staticRenderFns } from "./DeleteAkun.vue?vue&type=template&id=5193471c&scoped=true&"
import script from "./DeleteAkun.vue?vue&type=script&lang=js&"
export * from "./DeleteAkun.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAkun.vue?vue&type=style&index=0&id=5193471c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5193471c",
  null
  
)

export default component.exports